import { AddonItem } from '@intigral/shared/components/AddonItem';
import { AddonStaticItemProps } from '../../types/iAddonsCarousel';
import { useAddonsRedirection } from '../../hooks/useAddonsRedirection';

export const AddonStaticItem: React.FC<AddonStaticItemProps> = ({ item, index, carousel }) => {
    const { redirectToAddonsPage } = useAddonsRedirection();

    return (
        <AddonItem
            onClick={() => {
                redirectToAddonsPage(item, carousel);
            }}
            cost=""
            logo={item.logo}
            picture={item.mainImage}
            ctaPlay={undefined}
            ctaDetails={undefined}
            info={[]}
            isStatic={true}
        />
    );
};
